import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getJobsForProof({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_PROOF_JOBS_REQUEST')

        return axios
            .get(`/proof-jobs/proof-jobs${paginate}${query}`)
            .then(response => {
                commit('GET_PROOF_JOBS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PROOF_JOBS_FAILURE')
                handleApiError(error, 'Pobranie listy zleceń na proof nie powiodło się.')

                return Promise.reject(error)
            })
    },
    closeJobsForProof({ commit }, payload) {
        return axios
            .patch(`/proof-jobs/proof-jobs/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zlecenie na proof zostało zamknięte.',
                }, { root: true })

                return Promise.resolve(response)
                
            })
            .catch(error => {
                handleApiError(error, 'Zamknięcie zlecenia na proof nie powiodło się.')

                return Promise.reject(error)
            })
    },
}